import { detectIE, dataURIToBlob } from 'utils';
import html2canvas from 'html2canvas';
import XYZ from 'ol/source/XYZ';

export class ImageSaver {
    view: omjs.View = null;
    options = null;
    imgMap = null;

    constructor(view) {
        this.view = view;
    }

    getActiveLayerIds = () => {
        const layers = this.view.getLayers();
        let ids = [];

        layers.each((l) => {
            // Если слой отключен, он нам не нужен - пропускаем
            if (!l.isVisible()) {
                return;
            }

            // Все что можем привестти к тайловому слою приводим
            if (
                l instanceof omjs.View.TileLayer
                || l instanceof omjs.View.OmsVectorFeatureLayer
                || l instanceof omjs.View.MVTLayer
            ) {
                if (l.getSource() && l.getSource().getActiveLayers) {
                    ids = ids.concat(l.getSource().getActiveLayers());
                } else {
                    l.getProjectLayers().each((pl) => {
                        if (pl.get('selected')) {
                            ids.push(pl.get('id'));
                        }
                    });
                }
            }
        });

        return ids;
    };

    getVectorLayers() {
        const layers = this.view.getLayers().getArray();
        return layers.filter(l => (
            l instanceof omjs.View.VectorLayer
            && l.getProjectLayers() !== false
            && l.isVisible()
        )) as unknown as omjs.ViewVectorLayer[];
    }

    createBaseLayer = (scale) => {
        const mapBaseLayer = this.view.getBaseLayer();
        let resLayer = false;

        const bmSettings = mapBaseLayer.options.base_maps.filter(bm => bm.id === mapBaseLayer.currentSource)[0];

        // Бывает что подложек и нет)
        if (!bmSettings) {
            return resLayer;
        }

        // Если это экспериментальный вектор, пусть его рисует мапник
        if (bmSettings.type === 'OMS' && bmSettings.vector) {
            return mapBaseLayer._baseMapContaiers[bmSettings.id];
        // Если это XYZ
        } else if (bmSettings.type === 'XYZ' && mapBaseLayer.olLayer.getVisible()) {
            const rPixelRatio = /\{pixelratio([&?][^=]*)?=([^}]+)\}/;
            const res = bmSettings.value.match(rPixelRatio);
            let replacer = '';
            let xValues;
            let xVar = '';
            let xVal;
            let xyzUrl = bmSettings.value;
            let tilePixelRatio = 1;
            if (res) {
                if (res.length === 3) {
                    if (res[1]) {
                        xVar += `${res[1]}=`;
                    }
                    xValues = res[2].split(',');
                } else {
                    xValues = res[1].split(',');
                }

                if (scale === 1) {
                    xVal = xValues[scale - 1];
                } else {
                    for (let n = scale - 1; n > 0; n--) {
                        xVal = xValues[n];
                        if (xVal && xVal.trim() !== '') {
                            tilePixelRatio = n + 1;
                            break;
                        }
                    }
                }

                if (xVal && xVal.trim() !== '') {
                    replacer = xVar + xVal;
                }
                xyzUrl = xyzUrl.replace(res[0], replacer);
            }

            resLayer = new omjs.ol.layer.Tile({
                source: new omjs.ol.source.XYZ({
                    url: xyzUrl,
                    crossOrigin: 'anonymous',
                    tilePixelRatio: scale
                })
            });
            // Ну а если это еще что то то просто вернем слой
        } else if (mapBaseLayer.olLayer.getVisible()) {
            resLayer = new omjs.ol.layer.Tile({
                source: new omjs.ol.source.XYZ({
                    url: mapBaseLayer.olLayer.getSource().getUrls()[0],
                    crossOrigin: 'anonymous',
                    tilePixelRatio: scale
                })
            });
        }

        return resLayer;
    };

    drawTitle = (canvas, value) => {
        const element = document.createElement('div');
        element.innerHTML = value;
        element.className = 'map-title';
        document.querySelector('.omjs-map-container').appendChild(element);

        return html2canvas(element)
            .then((result) => {
                canvas.getContext('2d').drawImage(result, 0, 0);
                document.querySelector('.omjs-map-container').removeChild(element);
                result.remove();
            });
    };

    drawScaleBar = canvas => (
        html2canvas(document.querySelector('.ol-scale-line'))
            .then((result) => {
                canvas.getContext('2d').drawImage(
                    result, 5, this.imgMap.getSize()[1] * this.options.scale - 20
                );
            })
    );

    download = (canvas, name, format) => {
        let blob;
        let jpegCanvas;

        if (format === 'jpeg') {
            jpegCanvas = document.createElement('canvas');
            jpegCanvas.height = canvas.height;
            jpegCanvas.width = canvas.width;

            const ctx = jpegCanvas.getContext('2d');
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(canvas, 0, 0);
        }

        if (jpegCanvas) {
            blob = dataURIToBlob(jpegCanvas.toDataURL(`image/${format}`));
        } else {
            blob = dataURIToBlob(canvas.toDataURL(`image/${format}`));
        }

        const filename = `${name}.${format}`;

        if (detectIE()) {
            if ('msSaveBlob' in navigator) {
                navigator.msSaveBlob(blob, filename);
            }
        } else {
            const link = document.createElement('a');

            link.id = 'download_map_link';
            link.href = URL.createObjectURL(blob);
            link.download = filename;

            document.body.appendChild(link);
            document.getElementById('download_map_link').click();
            document.body.removeChild(link);
        }
    };

    saveImage = (options) => {
        const that = this;
        this.options = options;
        const map = this.view.getMap();
        const project = this.view.getProject();
        let mapLayers = [];
        let { tilesUrl, mapCode } = project.options;
        let activeTileLayerIds = this.getActiveLayerIds();

        // Контейнер для карты
        const cont = window['$']('<div id="imgMap"></div>')
            .css({
                width: map.getSize()[0],
                height: map.getSize()[1],
                position: 'absolute',
                left: -9999,
                top: -9999,
                'z-index': -1
            })
            .appendTo('body');

        // Подложка
        let baseLayer = this.createBaseLayer(options.scale);
        if (baseLayer) {
            if (!Array.isArray(baseLayer)) {
                mapLayers.push(baseLayer);
            } else {
                activeTileLayerIds = activeTileLayerIds.concat(baseLayer);
                baseLayer = false;
            }
        }

        // Слои кадастровой карты
        const pkkLayersGroup = this.view.getMap().getLayers().getArray().find(l => l.get('code') === 'PKK');
        if (pkkLayersGroup && pkkLayersGroup.getVisible()) {
            const layersGroup = new omjs.ol.layer.Group();

            pkkLayersGroup.getLayersArray().forEach((pkkLayer) => {
                const pkkLayerSource = pkkLayer.getSource();

                if (pkkLayerSource instanceof omjs.ol.source.XYZ) {
                    const pkkXYZLayer = new omjs.ol.layer.Tile({
                        ...pkkLayer.getProperties(),
                        source: new omjs.ol.source.XYZ({
                            urls: (pkkLayerSource as XYZ)
                                .getUrls()
                                .map((url) => {
                                    const urlObject = new URL(url);
                                    urlObject.searchParams.set('retina', options.scale);
                                    return decodeURIComponent(urlObject.href);
                                }),
                            tilePixelRatio: options.scale,
                            crossOrigin: 'anonymous'
                        })
                    });
                    layersGroup.getLayers().getArray().push(pkkXYZLayer);
                } else {
                    layersGroup.getLayers().getArray().push(pkkLayer);
                }
            });

            mapLayers.push(layersGroup);
        }

        // Url до тайлов
        tilesUrl = tilesUrl
            .replace('{map_code}', mapCode)
            .replace('{layers}', activeTileLayerIds.join(','));
        tilesUrl += `&retina=${options.scale}`;

        // Тайловый слой для загрузки всех слоев
        const tileSource = new omjs.ol.source.XYZ({
            url: tilesUrl,
            crossOrigin: 'anonymous',
            tilePixelRatio: options.scale
        });

        const tileLayer = new omjs.ol.layer.Tile({
            source: tileSource
        });

        mapLayers.push(tileLayer);

        // Получаем все векторные слои и подготавливаем их к танцам
        // Проставляем pixelRatio окну
        window['customDevicePixelRatio'] = options.scale;

        let vecLayers = this.getVectorLayers();
        vecLayers = vecLayers.map((vl) => {
            // @ts-ignore
            if (vl.setLayerStyle) {
                // @ts-ignore
                vl.pixelRatio = 1 / options.scale;
                // @ts-ignore
                vl.setLayerStyle();
            }
            return vl.getMapLayer();
        });

        mapLayers = mapLayers.concat(vecLayers);

        this.imgMap = new omjs.ol.Map({
            layers: mapLayers,
            pixelRatio: options.scale,
            target: 'imgMap',
            view: new omjs.ol.View({
                center: map.getView().getCenter(),
                zoom: map.getView().getZoom()
            })
        });

        // Сохранение
        let loading = 0;
        let loaded = 0;

        const tileLoadStart = function() {
            ++loading;
        };

        const tileLoadEnd = function() {
            ++loaded;

            if (loading === loaded) {
                const canvas = this;
                tileSource.un('tileloadstart', tileLoadStart);
                tileSource.un('tileloadend', tileLoadEnd, canvas);
                tileSource.un('tileloaderror', tileLoadEnd, canvas);

                if (baseLayer) {
                    const baseSource = baseLayer.getSource();
                    baseSource.un('tileloadstart', tileLoadStart);
                    baseSource.un('tileloadend', tileLoadEnd, canvas);
                    baseSource.un('tileloaderror', tileLoadEnd, canvas);
                }

                setTimeout(() => {
                    // title
                    const titleRenderPromise = options.showTitle
                        ? that.drawTitle(canvas, ' ')
                        : Promise.resolve();

                    // scaleBar
                    const scaleBarRenderPromise = that.drawScaleBar(canvas);

                    Promise.all([ titleRenderPromise, scaleBarRenderPromise ]).then(() => {
                        if (detectIE()) {
                            // TODO разобраться, для чего это
                            that.view.getMeasurement().setVisible(true);
                        }

                        that.download(canvas, that.view['_mapContainer'].get('code'), options.format);

                        window['customDevicePixelRatio'] = undefined;

                        that.getVectorLayers().forEach((vl) => {
                            // @ts-ignore
                            if (vl.setLayerStyle) {
                                // @ts-ignore
                                vl.pixelRatio = undefined;
                                // @ts-ignore
                                vl.setLayerStyle();
                            }
                        });

                        mapLayers.forEach((l) => {
                            that.imgMap.removeLayer(l);
                        });

                        that.imgMap.setTarget(null);
                        that.imgMap = null;
                        cont.remove();
                    });
                }, 500);
            }
        };

        that.imgMap.once('postcompose', (event) => {
            tileSource.on('tileloadstart', tileLoadStart);
            tileSource.on('tileloadend', tileLoadEnd.bind(event.context.canvas));
            tileSource.on('tileloaderror', tileLoadEnd.bind(event.context.canvas));

            if (baseLayer) {
                const baseSource = baseLayer.getSource();
                baseSource.on('tileloadstart', tileLoadStart);
                baseSource.on('tileloadend', tileLoadEnd.bind(event.context.canvas));
                baseSource.on('tileloaderror', tileLoadEnd.bind(event.context.canvas));
            }

            setTimeout(() => {
                if (!loaded && !loading) {
                    tileLoadEnd.call(event.context.canvas);
                }
            }, 300);
        });

        that.imgMap.renderSync();
    };
}
